import { useMemo } from 'react';

import { Trans, useLingui } from '@lingui/react/macro';
import { useAtomValue } from 'jotai';

import { selectedPlanAtom } from '../../../atoms';

import { MaximumsAndDeductiblesTable } from './MaximumsAndDeductiblesTable';

export const MaximumsAndDeductiblesSection = () => {
  // atoms
  const currentPlan = useAtomValue(selectedPlanAtom);

  // hooks
  const { t } = useLingui();

  // Transform Zuub maximums and deductibles data
  const maximumsAndDeductiblesData = useMemo(() => {
    if (!currentPlan?.maximumsAndDeductibles) {
      return { maximums: [], deductibles: [], isValid: false };
    }

    const { maximums, deductibles } = currentPlan.maximumsAndDeductibles;
    const hasMaximums = maximums && maximums.length > 0;
    const hasDeductibles = deductibles && deductibles.length > 0;

    return {
      maximums: maximums || [],
      deductibles: deductibles || [],
      isValid: hasMaximums || hasDeductibles,
    };
  }, [currentPlan]);

  // Only show data if we have valid maximums and deductibles data
  if (!maximumsAndDeductiblesData.isValid) {
    return (
      <div className="vai-text-center vai-text-gray-500 vai-py-8 vai-bg-gray-50 vai-rounded-lg">
        <Trans>
          No maximums and deductibles data available for the selected plan.
        </Trans>
      </div>
    );
  }

  return (
    <div className="vai-space-y-6">
      {/* Maximums Table */}
      <MaximumsAndDeductiblesTable
        data={maximumsAndDeductiblesData.maximums}
        title={t`Maximums`}
      />

      {/* Deductibles Table */}
      <MaximumsAndDeductiblesTable
        data={maximumsAndDeductiblesData.deductibles}
        title={t`Deductibles`}
      />
    </div>
  );
};
